import _LoadingOutlined from "@zenlayer/zen-design-icons/assets/LoadingOutlined.svg";
import classNames from 'classnames';
import React from 'react';
import { pickDomAttrs } from '../_util/utils';
import Icon from '../icon';
import { jsx as _jsx } from "react/jsx-runtime";
const Portal = props => {
  const {
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-loading-portal");
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsx("div", {
    ...attrs.data,
    className: classNames(baseClassName, className),
    style: style,
    children: /*#__PURE__*/_jsx(Icon, {
      type: "LoadingOutlined",
      spin: true,
      className: "loadingIcon"
    })
  });
};
const Page = props => {
  const {
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-loading-page");
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsx("div", {
    ...attrs.data,
    className: classNames(baseClassName, className),
    style: style,
    children: /*#__PURE__*/_jsx(Icon, {
      type: "LoadingOutlined",
      spin: true,
      className: "loadingIcon"
    })
  });
};
export default {
  Portal,
  Page
};